import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20d7b74f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginForm: require('/workspace/components/Login/LoginForm.vue').default,CardComponent: require('/workspace/components/CardComponent.vue').default})
